import React from 'react';

import Text from '../../Text';

function DropdownLabelContent(
{
  label,
  disabled,
  cutLongLabels




})
{
  if (label === void 0) {return null;}
  if (typeof label !== 'string') {return label;}

  return (
    <Text
      disabled={disabled}
      noMargin
      ellipsisOverflow={cutLongLabels}
      className="dropdown-option__content__label">

      {label}
    </Text>);

}

export default DropdownLabelContent;